import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import { updateExpiry } from '../../API/Payment/Payment';

function UpdateExpiryDialog({ organizationId, paymentMethodId, onUpdate, onClose }) {

    const [expiry, setExpiry] = useState('');
    const [isValidFormat, setIsValidFormat] = useState(true);
    const [isValid, setIsValid] = useState(true);

    function handleExpiryChange(event) {
        let { value } = event.target;
        
        // Auto-populate '/' when the first two characters are entered
        if (value.length === 2 && expiry.charAt(2) === '/') {
            // Remove the second character if the user attempts to remove '/'
            value = value.slice(0, 1);
        } else if (value.length === 2 && !value.includes('/')) {
            value += '/';
        } else if (value.length === 1 && parseInt(value, 10) > 1) {
            // If the user enters a single digit and it's greater than 1, format it to '0X/'
            value = `0${value}/`;
        }
      
        setExpiry(value);
        
        const [isValidFormat, isValidExpiry] = validateExpiry(value);
        setIsValidFormat(isValidFormat);
        setIsValid(isValidExpiry);
    };

    function validateExpiry(value) {
        // Validate MM/YY format using a regular expression
        const isValidFormat = /^(0[1-9]|1[0-2])\/\d{0,2}$/.test(value);
      
        let isValidExpiry = true;
      
        if (isValidFormat) {
            const [inputMonth, inputYear] = value.split('/');
            const currentYear = new Date().getFullYear() % 100;
            const currentMonth = new Date().getMonth() + 1;

            const expiryYear = parseInt(inputYear, 10);
            const expiryMonth = parseInt(inputMonth, 10);

            isValidExpiry = expiryYear > currentYear || (expiryYear === currentYear && expiryMonth >= currentMonth);
        }

        return [isValidFormat, isValidExpiry];
    }

    async function updatePaymentMethodExpiry() {
        const [expiryMonth, expiryYear] = expiry.split('/').map((value) => parseInt(value, 10)); // [MM, YY
        await updateExpiry(organizationId, paymentMethodId, expiryMonth, expiryYear);
        onUpdate({ paymentMethodId, expiryMonth, expiryYear });
    }

    return (
        <Dialog
            title="Update card"
            onClose={onClose}>
            <form>
                <div>
                    <label htmlFor="expiry">Card Expiry (MM/YY)</label>
                    <input
                        type="text"
                        id="expiry"
                        name="expiry"
                        placeholder="MM/YY"
                        value={expiry}
                        onChange={handleExpiryChange}
                        className='form-control'
                    />
                    {!isValidFormat && <p style={{ color: 'red' }}>Please enter a valid MM/YY format</p>}
                    {!isValid && <p style={{ color: 'red' }}>Please enter a valid expiry date</p>}
                </div>
            </form>
            <DialogActionsBar layout='end'>
                <div className='d-flex px-3 py-2'>
                    <button onClick={onClose} className='btn btn-secondary'>Cancel</button>
                    <button
                        disabled={!isValidFormat || !isValid}
                        className='btn btn-primary'
                        onClick={updatePaymentMethodExpiry}
                    >
                        Update
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    )
}

export default UpdateExpiryDialog;